import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import InputMask from 'react-input-mask'
import { InputLabel, TextField, FormHelperText } from '@material-ui/core'

export const CPF_SIZE_WITHOUT_MASK = 11
export const CNPJ_SIZE_WITHOUT_MASK = 14

const formatChars = {
  9: '[0-9]',
  '*': '[A-Za-z0-9]',
}

const CNPJ_MASK = '**.***.***/****-**'
const CPF_MASK = '***.***.***-******'

const CPFOrCNPJInput = (props) => {
  const {
    id, label, color, error, value, helpertext, onChange,
  } = props

  const [mask, setMask] = useState(CPF_MASK)

  const normalize = (val) => val?.replace(/[.\-/\s]/g, '') ?? ''

  const setMaskByValueLength = (normalizedValue) => {
    if (normalizedValue.length <= CPF_SIZE_WITHOUT_MASK) {
      setMask(CPF_MASK)
    } else {
      setMask(CNPJ_MASK)
    }
  }

  const handleChange = (event) => {
    const { value: valueChange } = event.target
    const normalized = normalize(valueChange)

    onChange({
      target: { id, value: normalized },
    })

    setMaskByValueLength(normalized)
  }

  useEffect(() => {
    if (value) {
      setMaskByValueLength(normalize(value))
    }
  }, [value])

  const field = useMemo(() => {
    const inputProps = { ...props }
    delete inputProps.onBlur
    delete inputProps.onChange
    delete inputProps.helpertext

    return <TextField {...inputProps} margin="normal" />
  }, [props])

  return (
    <>
      <InputLabel
        htmlFor={id}
        color={color}
        error={error}
      >
        {label}
      </InputLabel>

      <InputMask
        {...props}
        mask={mask}
        maskChar={null}
        formatChars={formatChars}
        onChange={handleChange}
      >
        {() => field}
      </InputMask>

      <FormHelperText hidden={!error} error={error}>{helpertext}</FormHelperText>
    </>
  )
}

CPFOrCNPJInput.propTypes = {
  color: PropTypes.oneOf(['primary', 'secondary']),
  error: PropTypes.bool,
  helpertext: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  onChange: PropTypes.func,
}

CPFOrCNPJInput.defaultProps = {
  color: 'secondary',
  error: false,
  helpertext: '',
  label: '',
  value: '',
  name: undefined,
  onBlur: () => { },
  onChange: () => { },
}

export default CPFOrCNPJInput
